// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AN_o","newExpiryDate":"styles_newExpiryDate__i_B6x","footer":"styles_footer__2WPgw"};